import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ResponsiveImg from '../../shared/ResponsiveImg';

import styles from './Triple.module.postcss';

// `children` render under the text (PS3/PS3b: the CTA row on the property
// pages' "What it costs" card). Only the plain variant takes them; a linked
// card is one anchor and can't nest buttons.
function Triple({ image, text, title, link, alt = '', isResponsive = false, children = null }) {
  if (link) {
    return (
      <div className={styles.Triple}>
        <Link to={link} >
          { !isResponsive &&
          <img className={styles.TripleImg} src={image} alt={alt} loading='lazy' />
          }
          { isResponsive &&
            <ResponsiveImg
              className={styles.TripleImg}
              src={image}
              widths={[400, 600, 800]}
              // `.Section` has 24px horizontal padding on each side below 732px,
              // so the actual image container is (100vw - 48px). Declaring
              // `100vw` made the browser pick the 800w variant on Lighthouse's
              // 412px mobile viewport when the container is actually 364px.
              sizes='(max-width: 900px) calc(100vw - 48px), 360px'
              alt={alt}
              loading='lazy'
              width={600}
              height={400}
            />
          }
          <h3>{title}</h3>
          <p>{text}</p>
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.Triple}>
      { !isResponsive &&
        <img className={styles.TripleImg} src={image} alt={alt} loading='lazy' />
      }
      { isResponsive &&
        <ResponsiveImg
          className={styles.TripleImg}
          src={image}
          widths={[400, 600, 800]}
          // See note above re: Section padding on mobile.
          sizes='(max-width: 900px) calc(100vw - 48px), 360px'
          alt={alt}
          loading='lazy'
          width={600}
          height={400}
        />
      }
      <h3>{title}</h3>
      <p>{text}</p>
      {children}
    </div>
  );
}

Triple.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  link: PropTypes.string,
  alt: PropTypes.string,
  isResponsive: PropTypes.bool,
  children: PropTypes.node,
};

export default Triple;
